define("shared/components/shared/stop-the-world-modal", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _tracking, _emberConcurrency, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.isVisible}}
    {{! @glint-expect-error: Shared::Modal is not a glint component }}
    <Shared::Modal @closable={{false}} as |modal|>
  
      <modal.card @portrait={{true}}>
        {{#if this.isNotAccountOwner}}
          <modal.card-header class="u--p__b__sm">
            <h2 class="o--modalHeader__title">{{t "account.past_due_modal.non_admin.title"}} </h2>
          </modal.card-header>
          <modal.card-body class="u--p__t__0">
            <section data-test-id="non-owner-past-due-modal">
              <div class="u--m__t__0">
                {{html-safe (t "account.past_due_modal.non_admin.description" email=this.accountOwnerEmail)}}
              </div>
            </section>
          </modal.card-body>
        {{else if this.isPastDue}}
          <modal.card-header @title={{t "account.past_due_modal.title"}} />
          <modal.card-body data-test-id="past-due-modal">
            <p>{{t "account.past_due_modal.description" cardNumber=this.cardNumber}}</p>
            <p>{{t "account.past_due_modal.description_downgrade_warning"}}</p>
          </modal.card-body>
          <modal.card-footer>
            {{#if this.rolloutPaymentMethods}}
              <Shared::Ui::Button
                @onClick={{this.redirectToPaymentMethod}}
                class="o--btn o--btn--primary u--float--right"
                {{track "past-due-modal-clicked-update-payment" "click" location="past due modal"}}
              >
                {{t "account.subscription.billing.update_card.title"}}
              </Shared::Ui::Button>
            {{else}}
              {{! @glint-expect-error: Shared::Button:UpdateCard is not a glint component }}
              <Shared::Button::UpdateCard
                @billingEmail={{this.accountOwnerEmail}}
                @buttonText={{t "account.subscription.billing.update_card.title"}}
                @handleCard={{this.handleStripeCard}}
                @isDisabled={{this.isChargingInvoice}}
                @variant="primary"
                class="u--float--right"
                data-test-id="update-card-button"
                {{track "past-due-modal-clicked-update-payment" "click" location="past due modal"}}
              />
            {{/if}}
          </modal.card-footer>
        {{else}}
          <modal.card-header @title={{t "account.stop_the_world.title" planName=this.planName}} />
  
          <modal.card-body>
  
            {{#if this.currentAccount.shouldWarnOfPlanOverages}}
              <p>{{t "account.stop_the_world.overages.message"}}</p>
              <ul>
                {{#if this.hasLinkinbioPagesOverage}}
                  <li>{{t "account.stop_the_world.overages.linkinbio_pages" count=this.linkinbioPagesOverage}}</li>
                {{/if}}
                {{#if this.currentAccount.hasGroupsOverage}}
                  <li>{{t "account.stop_the_world.overages.groups" count=this.currentAccount.groupsOverage}}</li>
                {{/if}}
  
                {{#if this.currentAccount.hasUsersOverage}}
                  <li>{{t "account.stop_the_world.overages.users" count=this.currentAccount.usersOverage}}</li>
                {{/if}}
  
                {{#if this.currentAccount.hasSocialProfileOverage}}
                  <li>
                    {{t
                      "account.stop_the_world.overages.social_profiles"
                      count=this.currentAccount.socialProfilesOverage
                    }}
                  </li>
                {{/if}}
              </ul>
            {{else}}
              <p>{{t "account.stop_the_world.generic_message"}}</p>
            {{/if}}
          </modal.card-body>
          <modal.card-footer>
            {{#unless this.isPastDue}}
              {{! @glint-expect-error: LinkToExternal is not a glint component }}
              <LinkToExternal @route="plans" class="o--btn o--btn--outline" data-test-link-external="plans">
                {{t "account.downgrade.go_to_plans"}}
              </LinkToExternal>
            {{/unless}}
            <LinkTo
              @route={{@routeToDowngrade}}
              class="o--btn o--btn--primary u--float--right"
              data-test-link={{@routeToDowngrade}}
            >
              {{t "shared_words.continue"}}
            </LinkTo>
          </modal.card-footer>
        {{/if}}
  
      </modal.card>
    </Shared::Modal>
  
  {{/if}}
  */
  {
    "id": "5AmdD/Ji",
    "block": "[[[41,[30,0,[\"isVisible\"]],[[[1,\"  \"],[8,[39,1],null,[[\"@closable\"],[false]],[[\"default\"],[[[[1,\"\\n\\n    \"],[8,[30,1,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"isNotAccountOwner\"]],[[[1,\"        \"],[8,[30,1,[\"card-header\"]],[[24,0,\"u--p__b__sm\"]],null,[[\"default\"],[[[[1,\"\\n          \"],[10,\"h2\"],[14,0,\"o--modalHeader__title\"],[12],[1,[28,[35,2],[\"account.past_due_modal.non_admin.title\"],null]],[1,\" \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n        \"],[8,[30,1,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n          \"],[10,\"section\"],[14,\"data-test-id\",\"non-owner-past-due-modal\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"u--m__t__0\"],[12],[1,\"\\n              \"],[1,[28,[35,3],[[28,[37,2],[\"account.past_due_modal.non_admin.description\"],[[\"email\"],[[30,0,[\"accountOwnerEmail\"]]]]]],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"]],[]],[[[41,[30,0,[\"isPastDue\"]],[[[1,\"        \"],[8,[30,1,[\"card-header\"]],null,[[\"@title\"],[[28,[37,2],[\"account.past_due_modal.title\"],null]]],null],[1,\"\\n        \"],[8,[30,1,[\"card-body\"]],[[24,\"data-test-id\",\"past-due-modal\"]],null,[[\"default\"],[[[[1,\"\\n          \"],[10,2],[12],[1,[28,[35,2],[\"account.past_due_modal.description\"],[[\"cardNumber\"],[[30,0,[\"cardNumber\"]]]]]],[13],[1,\"\\n          \"],[10,2],[12],[1,[28,[35,2],[\"account.past_due_modal.description_downgrade_warning\"],null]],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n        \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"rolloutPaymentMethods\"]],[[[1,\"            \"],[8,[39,4],[[24,0,\"o--btn o--btn--primary u--float--right\"],[4,[38,5],[\"past-due-modal-clicked-update-payment\",\"click\"],[[\"location\"],[\"past due modal\"]]]],[[\"@onClick\"],[[30,0,[\"redirectToPaymentMethod\"]]]],[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[35,2],[\"account.subscription.billing.update_card.title\"],null]],[1,\"\\n            \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"            \"],[8,[39,6],[[24,0,\"u--float--right\"],[24,\"data-test-id\",\"update-card-button\"],[4,[38,5],[\"past-due-modal-clicked-update-payment\",\"click\"],[[\"location\"],[\"past due modal\"]]]],[[\"@billingEmail\",\"@buttonText\",\"@handleCard\",\"@isDisabled\",\"@variant\"],[[30,0,[\"accountOwnerEmail\"]],[28,[37,2],[\"account.subscription.billing.update_card.title\"],null],[30,0,[\"handleStripeCard\"]],[30,0,[\"isChargingInvoice\"]],\"primary\"]],null],[1,\"\\n\"]],[]]],[1,\"        \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"        \"],[8,[30,1,[\"card-header\"]],null,[[\"@title\"],[[28,[37,2],[\"account.stop_the_world.title\"],[[\"planName\"],[[30,0,[\"planName\"]]]]]]],null],[1,\"\\n\\n        \"],[8,[30,1,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n\\n\"],[41,[30,0,[\"currentAccount\",\"shouldWarnOfPlanOverages\"]],[[[1,\"            \"],[10,2],[12],[1,[28,[35,2],[\"account.stop_the_world.overages.message\"],null]],[13],[1,\"\\n            \"],[10,\"ul\"],[12],[1,\"\\n\"],[41,[30,0,[\"hasLinkinbioPagesOverage\"]],[[[1,\"                \"],[10,\"li\"],[12],[1,[28,[35,2],[\"account.stop_the_world.overages.linkinbio_pages\"],[[\"count\"],[[30,0,[\"linkinbioPagesOverage\"]]]]]],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"currentAccount\",\"hasGroupsOverage\"]],[[[1,\"                \"],[10,\"li\"],[12],[1,[28,[35,2],[\"account.stop_the_world.overages.groups\"],[[\"count\"],[[30,0,[\"currentAccount\",\"groupsOverage\"]]]]]],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"currentAccount\",\"hasUsersOverage\"]],[[[1,\"                \"],[10,\"li\"],[12],[1,[28,[35,2],[\"account.stop_the_world.overages.users\"],[[\"count\"],[[30,0,[\"currentAccount\",\"usersOverage\"]]]]]],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"currentAccount\",\"hasSocialProfileOverage\"]],[[[1,\"                \"],[10,\"li\"],[12],[1,\"\\n                  \"],[1,[28,[35,2],[\"account.stop_the_world.overages.social_profiles\"],[[\"count\"],[[30,0,[\"currentAccount\",\"socialProfilesOverage\"]]]]]],[1,\"\\n                \"],[13],[1,\"\\n\"]],[]],null],[1,\"            \"],[13],[1,\"\\n\"]],[]],[[[1,\"            \"],[10,2],[12],[1,[28,[35,2],[\"account.stop_the_world.generic_message\"],null]],[13],[1,\"\\n\"]],[]]],[1,\"        \"]],[]]]]],[1,\"\\n        \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n\"],[41,[51,[30,0,[\"isPastDue\"]]],[[[1,\"            \"],[8,[39,8],[[24,0,\"o--btn o--btn--outline\"],[24,\"data-test-link-external\",\"plans\"]],[[\"@route\"],[\"plans\"]],[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[35,2],[\"account.downgrade.go_to_plans\"],null]],[1,\"\\n            \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"          \"],[8,[39,9],[[24,0,\"o--btn o--btn--primary u--float--right\"],[16,\"data-test-link\",[30,2]]],[[\"@route\"],[[30,2]]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,2],[\"shared_words.continue\"],null]],[1,\"\\n          \"]],[]]]]],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"]],[]]]],[]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[1]]]]],[1,\"\\n\\n\"]],[]],null]],[\"modal\",\"@routeToDowngrade\"],false,[\"if\",\"shared/modal\",\"t\",\"html-safe\",\"shared/ui/button\",\"track\",\"shared/button/update-card\",\"unless\",\"link-to-external\",\"link-to\"]]",
    "moduleName": "shared/components/shared/stop-the-world-modal.hbs",
    "isStrictMode": false
  });
  let StopTheWorldModalComponent = _exports.default = (_class = class StopTheWorldModalComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      //@deprecated event after rolloutPaymentMethods
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "cache", _descriptor3, this);
      _initializerDefineProperty(this, "events", _descriptor4, this);
      _initializerDefineProperty(this, "intl", _descriptor5, this);
      _initializerDefineProperty(this, "payment", _descriptor6, this);
      _initializerDefineProperty(this, "segment", _descriptor7, this);
      _initializerDefineProperty(this, "stripe", _descriptor8, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor9, this);
      _initializerDefineProperty(this, "router", _descriptor10, this);
      _initializerDefineProperty(this, "creditCard", _descriptor11, this);
      _initializerDefineProperty(this, "showSuccessModal", _descriptor12, this);
      _initializerDefineProperty(this, "isChargingInvoice", _descriptor13, this);
      /**
       * @deprecated after rolloutPaymentMethods
       */
      _defineProperty(this, "handleStripeCard", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (token) {
          this.isChargingInvoice = true;
          try {
            yield this.stripe.updateCard(token, {
              location: 'past due modal'
            });
            this.cache.remove('payment_method');
            yield this.payment.retrieveCard.perform();
          } catch (e) {
            this.alerts.warning(this.intl.t('alerts.account.subscription.billing.update_card.error'));
            this.isChargingInvoice = false;
          }
        }
      }), null, "handleStripeCard", "drop"));
      _defineProperty(this, "loadCard", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          this.creditCard = yield this.payment.retrieveCard.perform();
        }
      }), null, "loadCard", null));
      this.events.on('account:updated', this.handleAccountUpdate);
      if (this.isPastDue) {
        this.loadCard.perform();
      }
    }
    willDestroy() {
      super.willDestroy();
      //@deprecated event after rolloutPaymentMethods
      this.events.off('account:updated', this.handleAccountUpdate);
    }
    get rolloutPaymentMethods() {
      return this.auth.currentAccount.rolloutPaymentMethods;
    }
    get accountOwnerEmail() {
      return this.currentAccount.owner.get('email');
    }
    get cardNumber() {
      return this.creditCard?.card?.last4;
    }
    get currentAccount() {
      return this.auth.currentAccount;
    }
    get hasLinkinbioPagesOverage() {
      return this.currentAccount.hasOverageLinkinbioPages;
    }
    get isNotAccountOwner() {
      return !this.auth.currentUserModel?.isAccountOwner;
    }
    get linkinbioPagesOverage() {
      return this.currentAccount.linkinbioPagesOverage;
    }
    get planName() {
      return this.subscriptions.subscriptionPlan?.displayName;
    }
    get showLinkinbioWarning() {
      return this.currentAccount.linkinbioEnabled;
    }
    get isPastDue() {
      return this.subscriptions.isPastDue;
    }
    get isVisible() {
      return this.currentAccount.stopTheWorldOrPastDue;
    }

    /**
     * Note: using router.transitionTo in order to avoid checking for the need to use
     * LinkTo or LinkToExternal in the template.
     */
    redirectToPaymentMethod() {
      this.router.transitionTo('account.subscription.billing.payment_method');
    }
    /**
     * @deprecated after rolloutPaymentMethods
     */
    handleAccountUpdate() {
      if (this.isPastDue || this.isChargingInvoice) {
        this.alertFailedCharge();
        this.trackPaymentStatus();
        this.isChargingInvoice = false;
      }
    }

    /**
     * @deprecated after rolloutPaymentMethods
     */
    alertFailedCharge() {
      const threshold = 10;
      const timeDiff = Math.floor(Date.now() / 1000) - (this.currentAccount.lastFailedChargeAt ?? 0);
      if (this.isPastDue && timeDiff < threshold && this.isVisible) {
        this.segment.track('past-due-attempted-update-payment', {
          payment_status: 'failed'
        });
        this.alerts.warning(this.intl.t('alerts.account.subscription.billing.update_card.failed_charge'));
      }
    }

    /**
     * @deprecated after rolloutPaymentMethods
     */
    trackPaymentStatus() {
      const status = this.isPastDue ? 'failed' : 'success';
      this.segment.track('past-due-attempted-update-payment', {
        payment_status: status
      });
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "events", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "payment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "stripe", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "creditCard", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "showSuccessModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "isChargingInvoice", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "redirectToPaymentMethod", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "redirectToPaymentMethod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleAccountUpdate", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleAccountUpdate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "alertFailedCharge", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "alertFailedCharge"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackPaymentStatus", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackPaymentStatus"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, StopTheWorldModalComponent);
});